export const initialState = [
  {
    id: null,
    name: "",
    metadataLabel: "",
    accountFields: {
      fields: {},
      fieldsOrder: [],
      recordedFields: [],
      booleanFields: [],
    },
    supportedLanguages: [],
  },
];
